
export const NOTIFY = '@@NotificationSystem/Notify';
export const MESSAGE_HANDLED = '@@NotificationSystem/MessageHandled';